const commentData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20photography%20of%20a%20young%20professional%20with%20warm%20expression%2C%20studio%20lighting%2C%20minimal%20background%2C%20headshot%20style&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '3分钟前',
    content: '天呐这个瓜保真吗？细节也太详细了，感觉比当事人自己知道的都清楚，坐等后续反转！',
    likes: 2.3 + '万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20photography%20of%20a%20stylish%20young%20woman%20with%20confident%20look%2C%20studio%20lighting%2C%20minimal%20clean%20background%2C%20headshot%20style&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    name: '真相挖掘机',
    time: '15分钟前',
    content: '作为圈内人我只能说，爆料里说的只是冰山一角。真正的大瓜还在后面，各位准备好小板凳吧。',
    likes: 1.8 + '万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20photography%20of%20a%20fashionable%20person%20with%20mysterious%20smile%2C%20studio%20lighting%2C%20minimal%20background%2C%20editorial%20headshot%20style&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    name: '八卦研究员',
    time: '28分钟前',
    content: '这个时间线梳理得太清楚了！终于不用到处翻帖拼凑了，五一黑料网的汇总就是靠谱，已推荐给吃瓜群。',
    likes: 1.5 + '万',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            百万吃瓜群众的真实声音
          </p>
        </div>

        <div className="space-y-4">
          {commentData.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-sm text-foreground-800">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-700 mt-2 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4 pl-13">
                <span className="flex items-center gap-1.5 text-xs text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}